/**
 * The guild's unlisted videos on the Ravenguild YouTube channel. Each place on
 * the site that shows one reads it from here; a null id hides it until the
 * video has been uploaded. Posters live in public/videos, so nothing loads
 * from YouTube before someone presses play.
 */
export interface GuildVideo {
  /** The YouTube video id (the part after youtu.be/), null until uploaded */
  id: string | null
  title: string
  /** Our own poster; without one the player shows the title on a dark tile */
  poster?: string
}

export const GUILD_VIDEOS = {
  // Welcome page, under the hero: the short recruitment trailer. The long
  // guild history trailer (ui-iWz-le8w) is not shown on the site.
  trailer: { id: 'tRrgwn7Mi2I', title: 'Raven is recruiting', poster: '/videos/raven-recruitment-poster.jpg' },
  // DKP+ for members (rules and bidding): Welcome page under How loot works,
  // and the DKP+ page's Guide tab
  dkpRules: { id: '50QzusAzz0s', title: 'Raven DKP+: rules and bidding', poster: '/videos/dkp-rules-bidding-poster.jpg' },
  // The DKP+ page's Guide tab: running DKP+ as master looter. Shown to
  // everyone, not only officers, since any raider may loot a raid
  masterLooter: { id: 'P3k7h34CxOo', title: 'Raven DKP+: running loot as master looter', poster: '/videos/dkp-master-looter-poster.jpg' },
} satisfies Record<string, GuildVideo>
